"use client";

import { TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import {
  mergeFieldSx,
  requiredLabel,
} from "@/src/components/common/broadsheet/form-kit";

type FormTextFieldProps = {
  name: string;
  label: string;
  isRequired?: boolean;
  placeholder?: string;
  type?: string;
  multiline?: boolean;
  minRows?: number;
  maxRows?: number;
  helperText?: string;
  inputProps?: Record<string, any>;
  endAdornment?: React.ReactNode;
  sx?: Record<string, any>;
};

const FormTextField = ({
  name,
  label,
  isRequired = false,
  placeholder,
  type = "text",
  multiline = false,
  minRows,
  maxRows,
  helperText,
  inputProps,
  endAdornment,
  sx,
}: FormTextFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          size="small"
          margin="normal"
          type={type}
          multiline={multiline}
          minRows={minRows}
          maxRows={maxRows}
          placeholder={placeholder}
          label={requiredLabel(label, isRequired)}
          error={!!error}
          helperText={error?.message ?? helperText}
          value={field.value ?? ""}
          slotProps={{
            htmlInput: inputProps,
            input: { endAdornment },
          }}
          sx={mergeFieldSx(sx)}
        />
      )}
    />
  );
};

export default FormTextField;
